import reactStringReplace from "react-string-replace";

export default (string: any, terminology: TerminologyType<ITerminology>) => {
  let newString: React.ReactNodeArray = string;

  for (const item of Object.keys(terminology)) {
    //@ts-ignore
    const terminologyItem = terminology[ item ];

    if (terminologyItem.plural) {
      newString = reactStringReplace(newString, new RegExp(terminologyItem.plural.token, "g"), match => {
        return `${terminologyItem.plural.text} ${match}`;
      });
    }

    if (terminologyItem.singular) {
      newString = reactStringReplace(
        newString,
        new RegExp(terminologyItem.singular.token, "g"),
        match => `${terminologyItem.singular.text} ${match}`
      );
    }
  }

  if (typeof newString === "string") {
    return newString;
  } else {
    // @ts-ignore
    return newString.join("");
  }
};

export interface ITerminology {
  drop: ITerminologyItem;
  issue: ITerminologyItem;
  customer: ITerminologyItem;
  holiday: ITerminologyItem;
  product: ITerminologyItem;
  category: ITerminologyItem;
  delivery: ITerminologyItem;
  user: ITerminologyItem;
  order: ITerminologyItem;
  adhoc: ITerminologyItem;
  list: ITerminologyItem;
  notification: ITerminologyItem;
  schedule: ITerminologyItem;
  cutOff: ITerminologyItem;
  leadtime: ITerminologyItem;
  shelfLife: ITerminologyItem;
  cart: ITerminologyItem;
  partNumber: ITerminologyItem;
  fulfilment: ITerminologyItem;
}

export type TerminologyType<T = any> = { [P in keyof T]: ITerminologyItem };

export interface ITerminologyItem {
  singular: {
    text: string;
    token: RegExp;
  };
  plural: {
    text: string;
    token: RegExp;
  };
}
